import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as ReactJSSThemeProvider } from 'react-jss';
import { getClientEnvironmentDetails } from '@sm/utils';

// TODO: Kill this once all apps are using JSS and passing a theme
const ThemeProvider = ({ theme, children }) => {
  const { isBrowser } = getClientEnvironmentDetails();
  useEffect(() => {
    /**
     *  remove the JSS styles from the DOM after the client has loaded
     *  https://cssinjs.org/react-jss?v=v10.4.0#server-side-rendering
     */
    if (isBrowser) {
      const jss = document.getElementById('jss');
      if (jss) {
        jss.remove();
      }
    }
  }, [isBrowser]);

  return (
    <Choose>
      <When condition={Object.keys(theme).length > 0}>
        <ReactJSSThemeProvider theme={theme}>{children}</ReactJSSThemeProvider>
      </When>
      <Otherwise>{children}</Otherwise>
    </Choose>
  );
};

export const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  theme: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export const defaultProps = {
  theme: {},
};

ThemeProvider.propTypes = propTypes;
ThemeProvider.defaultProps = defaultProps;

export default ThemeProvider;
